import p1image1 from "./img/eg1.png";
import p1image2 from "./img/eg2.png";
import p1image3 from "./img/eg3.png";
import p2image1 from "./img/wc1.png";
import p2image2 from "./img/wc2.png";
import p2image3 from "./img/wc3.png";
import p3image1 from "./img/ipl1.png";
import p3image2 from "./img/ipl2.png";
import p3image3 from "./img/ipl3.png";
import p4image1 from "./img/am1.png";
import p4image2 from "./img/am2.png";
import p4image3 from "./img/am3.png";
import p5image1 from "./img/pathVisualizer1.png";
import p5image2 from "./img/pathVisualizer2.png";
import p5image3 from "./img/pathVisualizer3.png";

export const skillsData = [
  "Data Structures and Agorithms",
  "Statistical Analysis",
  "Machine Learning",
  "Deep Learning",
  "OpenVino",
  "Python",
  "R",
  "MySQL",
  "Power BI",
  "Tableau",
  "Docker",
  "MS-Excel",
  "PyTorch",
  "Git",
  "Web Scraping",
  "Computer Networks",
];

export const specifiedSkills = [
  "react",
  "nextJs",
  "MongoDb",
  "Tailwind",
  "Prisma",
];

export const projectsData = [
  {
    id: 1,
    projectName: "Cold-Email-Generator",
    image: p1image1,
    details:
      "The Cold Email Generator is a Streamlit application designed to help students and professionals craft personalized cold emails quickly and effectively. I developed this project using Python and LangChain to provide a platform where users can automatically generate personalized cold emails from job postings. This email generation platform required careful prompt engineering, with different components handling job data extraction, content generation, and error management for reliable email creation.",
    skills: ["Python", "Langchain", "LLM", "Streamlit"],
  },
  {
    id: 2,
    projectName: "ODI-World-Cup-2023-Analysis",
    image: p2image1,
    details:
      "The ODI World Cup 2023 Analysis is a data-driven project designed to uncover insights from the tournament's matches, helping fans and analysts better understand team and player performances. I used Python for data gathering and cleaning, along with Power BI for visualization, to create an interactive and informative analysis of the tournament.",
    skills: ["Python", "Web Scraping", "Power BI", "Pandas", "Data Analysis Expressions (DAX)"],
  },
  {
    id: 3,
    projectName: "IPL-Win-Predictor",
    image: p3image1,
    details:
      "The IPL Win Predictor is a machine learning-based model that predicts the probability of a team's victory in a match, based on specific game conditions and inputs. Developed in Python, it offers an intuitive, data-backed way to gauge potential outcomes and is designed for cricket enthusiasts seeking real-time, analytical insights.",
    skills: ["Python", "Machine Learning", "Numpy", "Pandas", "Scikit-learn", "Machine Learning"],
  },
  {
    id: 4,
    projectName: "Absenteeism-Model",
    image: p4image1,
    details:
      "The Absenteeism Model is a project that explores whether a person presenting certain characteristics is expected to be away from work at some point of time. This project aims to analyze the predicted outputs using Tableau.",
    skills: ["Python", "Tableau", "Machine Learning"],
  },
];

export const projectDetails = [
  {
    id: 1,
    name: ["C", "o", "l", "d", "-", "E", "m", "a", "i", "l", "-", "G", "e", "n", "e", "r", "a", "t", "o", "r"],
    liveServer:
      "https://ravitejavavilapalli-cold-email-generator.streamlit.app/",
    details:
      "The Cold Email Generator is a Streamlit application designed to help students and professionals craft personalized cold emails quickly and effectively. I developed this project using Python and LangChain to provide a platform where users can automatically generate personalized cold emails from job postings. This email generation platform required careful prompt engineering, with different components handling job data extraction, content generation, and error management for reliable email creation.",
    skills: ["Python", "Langchain", "LLM", "Streamlit"],
    image1: p1image1,
    goal: "The platform’s main goal is to automate the creation of tailored cold emails by analyzing job postings and matching them with the user's unique skills and experience. By leveraging LLM technology through the Groq API, users can input a job posting URL to receive a professionally crafted email response. This project addresses the time-consuming nature of writing personalized cold emails, helping job seekers make a strong first impression quickly and effectively.",
    image2: p1image2,
    aboutProject:
      "Streamlit was ideal for its rapid development and seamless Python integration, while LangChain provided robust LLM workflow management. The Groq API with the llama-3.1-70b model ensures high-quality text generation without requiring complex prompt tuning. Modular components for job data extraction and email generation maintain a clean and efficient codebase. Finally, Streamlit Cloud offers a straightforward deployment solution for this Python-based web app.",
    image3: p1image3,
    stack: ["S", "t", "a", "c", "k"],
    problemsAndThoughts:
      "Throughout the project, I encountered several challenges that enriched my skills as a developer. The most significant was fine-tuning prompts to consistently produce relevant email content, underscoring the importance of prompt engineering in AI applications. These obstacles deepened my understanding of practical LLM applications, improved my web scraping and text processing skills, and taught me how to effectively clean and structure job posting data—sharpening my overall technical proficiency in AI development.",
  },
  {
    id: 2,
    liveServer:
      "https://github.com/Ravitejaa45/ODI-World-Cup-2023-Analysis",
    name: ["O", "d", "i", "-", "W", "o", "r", "l", "d", "-", "C", "u", "p", "-", "2", "0", "2", "3"],
    details:
      "The ODI World Cup 2023 Analysis is a data-driven project designed to uncover insights from the tournament's matches, helping fans and analysts better understand team and player performances. I used Python for data gathering and cleaning, along with Power BI for visualization, to create an interactive and informative analysis of the tournament.",
    skills: ["Python", "Web Scraping", "Power BI", "Pandas", "Data Analysis Expressions (DAX)"],
    image1: p2image1,
    goal: "The primary goal of this project is to provide an analytical perspective on the ODI World Cup 2023, capturing trends in match performance, team statistics, and individual player contributions. The dashboard simplifies complex data, making it accessible to users interested in strategic insights, such as team selection or match prediction.",
    image2: p2image2,
    aboutProject:
      "For data extraction, I utilized web scraping to collect comprehensive cricket data from ESPNcricinfo. I then applied data cleaning and transformation techniques in Python with Pandas, followed by further data modeling in Power BI using Data Analysis Expressions (DAX). Power Query and DAX enabled dynamic data interaction within a Power BI dashboard, which presented user-friendly visualizations to highlight key metrics.",
    image3: p2image3,
    stack: ["S", "t", "a", "c", "k"],
    problemsAndThoughts:
      "A key challenge was managing diverse data sources and ensuring the data was clean, consistent, and accurate. Through this project, I gained valuable skills in data transformation and visualization, learning how to present intricate statistics in an accessible format. This enhanced my understanding of sports analytics and improved my proficiency in creating interactive dashboards.",
  },
  {
    id: 3,
    name: ["I", "P", "L", "-", "W", "i", "n", "-", "P", "r", "e", "d", "i", "c", "t", "o", "r"],
    liveServer:
      "https://ravitejavavilapalli-ipl-win-predictor.streamlit.app/",
    details:
      "The IPL Win Predictor is a machine learning-based model that predicts the probability of a team's victory in a match, based on specific game conditions and inputs. Developed in Python, it offers an intuitive, data-backed way to gauge potential outcomes and is designed for cricket enthusiasts seeking real-time, analytical insights.",
    skills: ["Python", "Machine Learning", "Numpy", "Pandas", "Scikit-learn", "Machine Learning"],
    image1: p3image1,
    goal: "This project’s goal is to simplify match predictions by allowing users to input match conditions and get a probability of winning for each team. The model enhances fan engagement and offers a predictive edge, making match analysis more interactive and insightful.",
    image2: p3image2,
    aboutProject:
      "I developed the predictor using Python for data preprocessing, cleaning, and modeling, leveraging libraries like NumPy, Pandas, and Scikit-learn for accurate results. Streamlit served as the deployment platform, making the model easily accessible through an interactive web interface.",
    image3: p3image3,
    stack: ["S", "t", "a", "c", "k"],
    problemsAndThoughts:
      "Handling the nuances of cricket data, including match conditions and dynamic variables, posed challenges in preprocessing. Through this project, I strengthened my skills in feature engineering and model tuning. Streamlit's deployment capabilities allowed me to create a user-friendly application that enhances audience interaction.",
  },
  {
    id: 4,
    name: ["A", "b", "s", "e", "n", "t", "e", "e", "i", "s", "m", "-", "M", "o", "d", "e", "l"],
    liveServer: "https://github.com/Ravitejaa45/Absenteeism_Model",
    details:
      "The Absenteeism Model is a project that explores whether a person presenting certain characteristics is expected to be away from work at some point of time. This project aims to analyze the predicted outputs using Tableau.",
    skills: ["Python", "Tableau", "Machine Learning"],
    image1: p4image1,
    goal: "The primary goal of this project is to develop a machine learning model that can predict the likelihood of employee absenteeism based on various factors. By analyzing the predicted outputs, the project aims to provide insights that can help organizations better understand and manage employee attendance patterns.",
    image2: p4image2,
    aboutProject:
      "For this project, I used Python for data preprocessing, cleaning, and modeling. I leveraged libraries like NumPy, Pandas, and Scikit-learn to build and train the machine learning model. To visualize the predicted outputs, I utilized Tableau, a powerful data visualization tool, which allowed me to create interactive and informative dashboards.",
    image3: p4image3,
    stack: ["S", "t", "a", "c", "k"],
    problemsAndThoughts:
      "One of the key challenges in this project was handling the complexities of employee attendance data, which often includes various factors such as personal, professional, and organizational elements. Through feature engineering and model selection, I worked to identify the most relevant predictors of absenteeism. The use of Tableau enabled me to present the model's insights in a user-friendly and visually appealing manner, facilitating better decision-making for organizations.",
  },
];
